const BodyTextWidth = {
  SHORT: 'short',
  LONG: 'long',
};
module.exports = BodyTextWidth;
